<div class="box-form">
  <div class="left">
    <div class="overlay">
      <h1>S. STOCK</h1>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        Curabitur et est sed felis aliquet sollicitudin</p>
    </div>
  </div>

  <div class="right">
      <h5>Fidirana</h5>
      <p>Eto ny <a href="#">Fisoratana anarana</a> raha mbola tsy nisoratra anarana</p>
      <div class="inputs">
        <input type="text" placeholder="anarana"  [(ngModel)]="username" required>
        <br>
        <input type="password" placeholder="teny miafina" [(ngModel)]="password" required>
      </div>

      <br><br>

      <div *ngIf="errorMessage">
        <p>{{ errorMessage }}</p>
      </div>

      <br>
      <button type="submit" class="btn btn-primary" (click)="onSubmit()">Miditra</button>
  </div>

</div>
